module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "postInfo"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: ("/life/" + _vm.slug)
      }
    },
    on: {
      "click": function($event) {
        return _vm.goToArticle(_vm.slug)
      }
    }
  }, [_c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: ("url('" + _vm.image + "')")
    })
  }), _vm._v(" "), _c('h3', {
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "date"
  }, [_c('mu-icon', {
    attrs: {
      "value": "watch_later",
      "color": "#5b617c"
    }
  }), _vm._v(" "), _c('time', {
    attrs: {
      "datetime": _vm.time
    },
    domProps: {
      "textContent": _vm._s(_vm.moment(_vm.time).fromNow())
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "favourites"
  }, [_c('mu-icon', {
    attrs: {
      "value": "favorite",
      "color": "#d83e38"
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.favourites)
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55d3e8a3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LifeStyle/LifePostInfo/LifePostInfo.vue
// module id = 3734
// module chunks = 1